export { default as DataTable } from './data-table.vue'
export { default as TimeSpan } from './timespan.vue'
export { default as IconTitle } from './icon-title.vue'
export { default as TableTitle } from './tableTitle.vue'
export { default as PageTitle } from './pagetitle.vue'
export { default as TabContent } from './tab-content.vue'
export { default as DownloadBtn } from './downloadBtn.vue'
export { default as CustomDatePicker } from './datepicker-custom.vue'
export { default as CompTimeSpan } from './comparetimespan.vue'
export { default as Search } from './search.vue'
export { default as DomainSelect } from './domain-select.vue'
export { default as IndiceCompare } from './indiceCompare.vue'
export {
  LineChart,
  PieChart,
  MapChart,
  BarChart,
  QuadChart
} from './charts/index.js'
export { default as VueSwitch } from './switch.vue'
// web 中使用的component
export { default as CustomIndice } from './custom-indice.vue'
export { default as DateCompare } from './date-compare.vue'
export { default as RadioSquare } from './radio-square.vue'
export { default as TopStatis } from './top-statis.vue'
export { default as Cascader } from './cascader.vue'
export { default as MutilSelect } from './mutilselect.vue'

export { default as InfoTip } from './infotip.vue'

export { default as Login } from './login.vue'



// WEBPACK FOOTER //
// ./src/component/index.js